import React from "react";
import {Outlet} from "react-router-dom";
import Menu from "routes/Menu";

const Faculty = () => {
  Menu(2);
  return (
    <>
      <Outlet />
    </>
  );
};

export default Faculty;
